import React from 'react';
import { Box, ModalClose } from '@mui/joy';
import { BreadCrumb, DetailTitle } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';

const LogData = (params) => {
    const { t } = useTranslation();
    const { data, action, subtitle } = params;

    return (
        <>
            {params.isDrawer && (
                <Box className="drawer-section-header">
                    <ModalClose />
                    <DetailTitle
                        title={action ? `${t('Action')}: ${action}` : t('Data')}
                        subtitle={subtitle ?? t('Data')}
                    />
                </Box>
            )}
            <BreadCrumb />
            <Box className="drawer-section-content drawer-section-content-embedded form-element col-12">
                {data != null ? (
                    <JSONPretty data={data} className="json-wrapper" />
                ) : (
                    <Box sx={{ p: 2 }}>{t('No data available')}</Box>
                )}
            </Box>
        </>
    );
};

export default LogData;
